export default __webpack_public_path__ + "static/media/imagen-fondo-pie-menu.3b4dc641.svg";